import { Circle, Path, Svg } from "@react-pdf/renderer";

type ValidatedIconProps = {
  style?: React.ComponentProps<typeof Svg>["style"];
};

export const ValidatedIcon = ({ style }: ValidatedIconProps) => {
  return (
    <Svg width="30" height="30" viewBox="0 0 30 30" style={style}>
      <Circle cx="15" cy="15" r="15" fill="#FDFDFE" />
      <Path
        d="M14.6049 6.00137C11.816 5.94956 9.08289 7.37317 7.43989 9.97227C5.10166 13.6661 5.66212 18.6447 8.7509 21.6492C11.837 24.6528 16.5416 24.794 19.7856 21.9815C22.8981 19.283 23.7722 14.6362 21.9539 10.8782L23.7901 8.57527C24.2684 7.99109 23.8762 7.08036 23.1484 7.08797C22.8999 7.09035 22.6647 7.20918 22.5067 7.41405L15.1235 16.6692C14.7723 17.1098 14.2056 17.1341 13.8267 16.7257L11.3238 14.0273C10.9963 13.676 10.4617 13.6708 10.1288 14.0197C9.79953 14.3686 9.79686 14.9385 10.1244 15.2898L12.6273 17.9882C13.6777 19.12 15.4443 19.0458 16.409 17.8352L20.7504 12.3884C21.8057 15.2603 21.0337 18.5843 18.7214 20.5907C16.1163 22.8485 12.3671 22.7372 9.88744 20.323C7.40776 17.9088 6.96332 13.9432 8.83881 10.9747C10.7143 8.00631 14.3332 6.95678 17.364 8.49589C17.7865 8.7193 18.2984 8.53345 18.5005 8.08046C18.7026 7.62699 18.5188 7.08512 18.0909 6.87502C17.148 6.39732 16.1578 6.11925 15.1623 6.03084C14.9771 6.01563 14.7915 6.00422 14.6049 6.00137Z"
        fill="#8DBE89"
      />
    </Svg>
  );
};
